export default __webpack_public_path__ + "static/media/contact-hero.79239731.jpg";